<template>
  <div v-if="!isMobile">
    <nav>
      <v-app-bar app height="80">
        <v-toolbar-title>
          <v-breadcrumbs :items="items" large></v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="pa-1 mr-1">
          <v-select
            :items="boardName"
            value="boardName1A"
            label="Board Name"
            v-model="boardItem"
            @change="updateBoard"
            :item-text="
              (boardName) => {
                return boardName.boardName1;
              }
            "
            prepend-inner-icon="mdi-integrated-circuit-chip"
            solo
            outlined
            dense
            hide-details
          >
          </v-select>
        </div>
        <v-md-date-range-picker :presets="presets" opens="right" @change="updateData">
          <v-card class="pa-2" slot="input" style="outline:1px solid grey;">
            <v-icon color="red darken-2"> mdi-clock-outline </v-icon> <span style="font-size: 15px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
          </v-card>
        </v-md-date-range-picker>
      </v-app-bar>
    </nav>
    <v-container v-if="loading">
      <v-skeleton-loader v-bind="attrs" type="table-thead, table-tbody"></v-skeleton-loader>
    </v-container>
    <v-container v-else>
      <v-row v-if="board.length == 0">
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="color:white;">
                    DB Board
                  </th>
                  <th class="text-left" style="color:white;">
                    Phase Label
                  </th>
                  <th class="text-left" style="color:white;">
                    Location (Room by Google)
                  </th>
                  <th class="text-left" style="color:white;">
                    Recent Consumption
                  </th>
                  <th class="text-left" style="color:white;">
                    Total Power Query Period
                  </th>
                  <th class="text-left" style="color:white;">
                    Load Type
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="color:white;">
                    DB Board
                  </th>
                  <th class="text-left" style="color:white;">
                    Phase Label
                  </th>
                  <th class="text-left" style="color:white;">
                    Location (Room by Google)
                  </th>
                  <th class="text-left" style="color:white;">
                    Recent Consumption
                  </th>
                  <th class="text-left" style="color:white;">
                    Total Power Query Period
                  </th>
                  <th class="text-left" style="color:white;">
                    Load Type
                  </th>
                </tr>
              </thead>
              <tbody @click="c_1A">
                <tr v-if="location1A.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[0].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1B">
                <tr v-if="location1B.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[1].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1C">
                <tr v-if="location1C.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[2].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1D">
                <tr v-if="location1D.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[3].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1E">
                <tr v-if="location1E.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[4].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1F">
                <tr v-if="location1F.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[5].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1G">
                <tr v-if="location1G.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[6].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1H">
                <tr v-if="location1H.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[7].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2A">
                <tr v-if="location2A.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[8].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2B">
                <tr v-if="location2B.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[9].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2C">
                <tr v-if="location2C.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[10].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2D">
                <tr v-if="location2D.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[11].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2E">
                <tr v-if="location2E.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[12].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2F">
                <tr v-if="location2F.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[13].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2G">
                <tr v-if="location2G.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[14].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2H">
                <tr v-if="location2H.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[15].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3A">
                <tr v-if="location3A.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[16].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3B">
                <tr v-if="location3B.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[17].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3C">
                <tr v-if="location3C.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[18].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3D">
                <tr v-if="location3D.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[19].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3E">
                <tr v-if="location3E.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[20].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3F">
                <tr v-if="location3F.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[21].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3G">
                <tr v-if="location3G.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[22].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3H">
                <tr v-if="location3H.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ total[23].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4A">
                <tr v-if="location4A.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[24].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4B">
                <tr v-if="location4B.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[25].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4C">
                <tr v-if="location4C.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[26].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4D">
                <tr v-if="location4D.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[27].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4E">
                <tr v-if="location4E.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[28].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4F">
                <tr v-if="location4F.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[29].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4G">
                <tr v-if="location4G.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[30].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4H">
                <tr v-if="location4H.slice(-1)[0] != ''">
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ total[31].toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>

  <div v-else>
    <div class="mt-5 pa-1" justify="center" align="center">
      <div class="pa-1">
        <v-select
          :items="boardName"
          value="boardName1A"
          label="Board Name"
          v-model="boardItem"
          @change="updateBoard"
          :item-text="
            (boardName) => {
              return boardName.boardName1;
            }
          "
          prepend-inner-icon="mdi-integrated-circuit-chip"
          outlined
          dense
          hide-details
        ></v-select>
      </div>
      <div class="pa-1">
        <v-card style="text-align:left; display:flex; justify-content:space-between;">
          <v-md-date-range-picker :presets="presets" opens="left" @change="updateData">
            <v-card class="pa-3" slot="input" flat>
              <v-icon color="red darken-2"> mdi-clock-outline </v-icon><span style="font-size: 12px; margin-left: 5px;">{{ formatDate($store.state.dateTime1) }} - {{ formatDate($store.state.dateTime2) }}</span>
            </v-card>
          </v-md-date-range-picker>
        </v-card>
      </div>
    </div>

    <v-container v-if="loading">
      <v-skeleton-loader v-bind="attrs" type="table-thead, table-tbody"></v-skeleton-loader>
    </v-container>
    <v-container v-else>
      <v-row v-if="board.length == 0">
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="color:white;">
                    DB Board
                  </th>
                  <th class="text-left" style="color:white;">
                    Phase Label
                  </th>
                  <th class="text-left" style="color:white;">
                    Location (Room by Google)
                  </th>
                  <th class="text-left" style="color:white;">
                    Recent Consumption
                  </th>
                  <th class="text-left" style="color:white;">
                    Total Power Query Period
                  </th>
                  <th class="text-left" style="color:white;">
                    Load Type
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                  <td>No Data</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" style="color:white;">
                    DB Board
                  </th>
                  <th class="text-left" style="color:white;">
                    Phase Label
                  </th>
                  <th class="text-left" style="color:white;">
                    Location (Room by Google)
                  </th>
                  <th class="text-left" style="color:white;">
                    Recent Consumption
                  </th>
                  <th class="text-left" style="color:white;">
                    Total Power Query Period
                  </th>
                  <th class="text-left" style="color:white;">
                    Load Type
                  </th>
                </tr>
              </thead>
              <tbody @click="c_1A">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1A.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1B">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1B.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1C">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1C.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1D">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1D.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1E">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1E.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1F">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1F.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1G">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1G.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_1H">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName1H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel1H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location1H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value1H.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 1 || totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType1H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2A">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2A.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2B">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2B.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2C">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2C.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2D">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2D.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2E">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2E.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2F">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2F.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2G">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2G.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_2H">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName2H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel2H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location2H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value2H.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 2 || totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType2H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3A">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3A.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3B">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3B.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3C">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3C.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3D">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3D.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3E">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3E.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3F">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3F.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3G">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3G.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_3H">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ boardName3H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel3H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ location3H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">{{ value3H.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 3 || totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType3H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4A">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4A.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4A.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4A.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4A
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4B">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4B.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4B.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4B.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4B
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4C">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4C.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4C.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4C.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4C
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4D">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4D.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4D.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4D.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4D
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4E">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4E.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4E.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4E.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4E
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4F">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4F.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4F.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4F.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4F
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4G">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4G.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4G.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4G.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4G
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
              <tbody @click="c_4H">
                <tr>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ boardName4H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ phaseLabel4H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ location4H.slice(-1)[0] }}</td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4H.slice(-1)[0] }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">{{ value4H.reduce((a, b) => a + b, 0).toFixed(2) }}<span style="font-size: 11px;">A</span></td>
                  <td v-if="totalSensorAll.slice(-1)[0] == 4">
                    {{
                      loadType4H
                        .slice(-1)[0]
                        .map(({ loadType, quantity }) => loadType + " " + "x" + " " + quantity)
                        .join(" ")
                    }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import axios from "axios";
  import moment from "moment";
  import router from "../../router";

  export default {
    data: () => ({
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Energy",
          disabled: true,
          href: "",
        },
        {
          text: "Usage By DB-MCB",
          disabled: true,
          href: "",
        },
      ],
      isMobile: true,
      // values1: moment().subtract(24, "hour"),
      // values2: moment().endOf("day"),
      presets: [
        {
          label: "Last 1 Hour",
          range: [moment().subtract(1, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 3 Hour",
          range: [moment().subtract(3, "hour"), moment().endOf("day")],
        },
        {
          label: "Last 12 Hour",
          range: [moment().subtract(12, "hour"), moment().endOf("day")],
        },
        {
          label: "Today",
          range: [moment().startOf("day"), moment().endOf("day")],
        },
        {
          label: "This Week",
          range: [
            moment()
              .clone()
              .startOf("week"),
            moment()
              .clone()
              .endOf("week"),
          ],
        },
        {
          label: "Last Week",
          range: [
            moment()
              .subtract(1, "weeks")
              .startOf("week"),
            moment()
              .subtract(1, "week")
              .endOf("week"),
          ],
        },
        {
          label: "This Month",
          range: [
            moment()
              .startOf("month")
              .startOf("day"),
            moment().endOf("month"),
          ],
        },
        {
          label: "Last Month",
          range: [
            moment()
              .subtract(1, "month")
              .startOf("month"),
            moment()
              .subtract(1, "month")
              .endOf("month"),
          ],
        },
      ],
      loading: true,
      board: [],
      total: [],
      totalSensorAll: [],

      boardName1A: [],
      phaseLabel1A: [],
      location1A: [],
      value1A: [],
      loadType1A: [],

      boardName1B: [],
      phaseLabel1B: [],
      location1B: [],
      value1B: [],
      loadType1B: [],

      boardName1C: [],
      phaseLabel1C: [],
      location1C: [],
      value1C: [],
      loadType1C: [],

      boardName1D: [],
      phaseLabel1D: [],
      location1D: [],
      value1D: [],
      loadType1D: [],

      boardName1E: [],
      phaseLabel1E: [],
      location1E: [],
      value1E: [],
      loadType1E: [],

      boardName1F: [],
      phaseLabel1F: [],
      location1F: [],
      value1F: [],
      loadType1F: [],

      boardName1G: [],
      phaseLabel1G: [],
      location1G: [],
      value1G: [],
      loadType1G: [],

      boardName1H: [],
      phaseLabel1H: [],
      location1H: [],
      value1H: [],
      loadType1H: [],

      boardName2A: [],
      phaseLabel2A: [],
      location2A: [],
      value2A: [],
      loadType2A: [],

      boardName2B: [],
      phaseLabel2B: [],
      location2B: [],
      value2B: [],
      loadType2B: [],

      boardName2C: [],
      phaseLabel2C: [],
      location2C: [],
      value2C: [],
      loadType2C: [],

      boardName2D: [],
      phaseLabel2D: [],
      location2D: [],
      value2D: [],
      loadType2D: [],

      boardName2E: [],
      phaseLabel2E: [],
      location2E: [],
      value2E: [],
      loadType2E: [],

      boardName2F: [],
      phaseLabel2F: [],
      location2F: [],
      value2F: [],
      loadType2F: [],

      boardName2G: [],
      phaseLabel2G: [],
      location2G: [],
      value2G: [],
      loadType2G: [],

      boardName2H: [],
      phaseLabel2H: [],
      location2H: [],
      value2H: [],
      loadType2H: [],

      boardName3A: [],
      phaseLabel3A: [],
      location3A: [],
      value3A: [],
      loadType3A: [],

      boardName3B: [],
      phaseLabel3B: [],
      location3B: [],
      value3B: [],
      loadType3B: [],

      boardName3C: [],
      phaseLabel3C: [],
      location3C: [],
      value3C: [],
      loadType3C: [],

      boardName3D: [],
      phaseLabel3D: [],
      location3D: [],
      value3D: [],
      loadType3D: [],

      boardName3E: [],
      phaseLabel3E: [],
      location3E: [],
      value3E: [],
      loadType3E: [],

      boardName3F: [],
      phaseLabel3F: [],
      location3F: [],
      value3F: [],
      loadType3F: [],

      boardName3G: [],
      phaseLabel3G: [],
      location3G: [],
      value3G: [],
      loadType3G: [],

      boardName3H: [],
      phaseLabel3H: [],
      location3H: [],
      value3H: [],
      loadType3H: [],

      boardName4A: [],
      phaseLabel4A: [],
      location4A: [],
      value4A: [],
      loadType4A: [],

      boardName4B: [],
      phaseLabel4B: [],
      location4B: [],
      value4B: [],
      loadType4B: [],

      boardName4C: [],
      phaseLabel4C: [],
      location4C: [],
      value4C: [],
      loadType4C: [],

      boardName4D: [],
      phaseLabel4D: [],
      location4D: [],
      value4D: [],
      loadType4D: [],

      boardName4E: [],
      phaseLabel4E: [],
      location4E: [],
      value4E: [],
      loadType4E: [],

      boardName4F: [],
      phaseLabel4F: [],
      location4F: [],
      value4F: [],
      loadType4F: [],

      boardName4G: [],
      phaseLabel4G: [],
      location4G: [],
      value4G: [],
      loadType4G: [],

      boardName4H: [],
      phaseLabel4H: [],
      location4H: [],
      value4H: [],
      loadType4H: [],
      tab: null,
      boardName: [],
      boardItem: [],
    }),
    mounted() {
      this.loadsBoard();
      this.loadsTotal();
      this.loadsBoardName();
      this.intervalFetchData();
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
    },
    methods: {
      intervalFetchData: function() {
        setInterval(() => {
          this.loadsBoard(), this.loadsTotal();
        }, 60000);
      },
      onResize() {
        this.isMobile = window.innerWidth < 700;
      },
      c_1A() {
        router.push("/board/C_1A/" + this.boardItem);
      },
      c_1B() {
        router.push("/board/C_1B/" + this.boardItem);
      },
      c_1C() {
        router.push("/board/C_1C/" + this.boardItem);
      },
      c_1D() {
        router.push("/board/C_1D/" + this.boardItem);
      },
      c_1E() {
        router.push("/board/C_1E/" + this.boardItem);
      },
      c_1F() {
        router.push("/board/C_1F/" + this.boardItem);
      },
      c_1G() {
        router.push("/board/C_1G/" + this.boardItem);
      },
      c_1H() {
        router.push("/board/C_1H/" + this.boardItem);
      },
      c_2A() {
        router.push("/board/C_2A/" + this.boardItem);
      },
      c_2B() {
        router.push("/board/C_2B/" + this.boardItem);
      },
      c_2C() {
        router.push("/board/C_2C/" + this.boardItem);
      },
      c_2D() {
        router.push("/board/C_2D/" + this.boardItem);
      },
      c_2E() {
        router.push("/board/C_2E/" + this.boardItem);
      },
      c_2F() {
        router.push("/board/C_2F/" + this.boardItem);
      },
      c_2G() {
        router.push("/board/C_2G/" + this.boardItem);
      },
      c_2H() {
        router.push("/board/C_2H/" + this.boardItem);
      },
      c_3A() {
        router.push("/board/C_3A/" + this.boardItem);
      },
      c_3B() {
        router.push("/board/C_3B/" + this.boardItem);
      },
      c_3C() {
        router.push("/board/C_3C/" + this.boardItem);
      },
      c_3D() {
        router.push("/board/C_3D/" + this.boardItem);
      },
      c_3E() {
        router.push("/board/C_3E/" + this.boardItem);
      },
      c_3F() {
        router.push("/board/C_3F/" + this.boardItem);
      },
      c_3G() {
        router.push("/board/C_3G/" + this.boardItem);
      },
      c_3H() {
        router.push("/board/C_3H/" + this.boardItem);
      },
      c_4A() {
        router.push("/board/C_4A/" + this.boardItem);
      },
      c_4B() {
        router.push("/board/C_4B/" + this.boardItem);
      },
      c_4C() {
        router.push("/board/C_4C/" + this.boardItem);
      },
      c_4D() {
        router.push("/board/C_4D/" + this.boardItem);
      },
      c_4E() {
        router.push("/board/C_4E/" + this.boardItem);
      },
      c_4F() {
        router.push("/board/C_4F/" + this.boardItem);
      },
      c_4G() {
        router.push("/board/C_4G/" + this.boardItem);
      },
      c_4H() {
        router.push("/board/C_4H/" + this.boardItem);
      },
      formatDate(value) {
        return moment(value).format("D MMM YYYY, h:mm:ss a");
      },
      loadsTotal: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/" + this.boardItem + "/total/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();
        axios
          .get(apiURL)
          .then((res) => {
            this.total = res.data.map((total) => total.total);
          })
          .catch((error) => {
            console.log(error);
          });
      },
      loadsBoard: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/ecms/" + this.boardItem + "/" + this.$store.state.dateTime1.toDate() + "/" + this.$store.state.dateTime2.toDate();

        const bName = ["1A", "1B", "1C", "1D", "1E", "1F", "1G", "1H", "2A", "2B", "2C", "2D", "2E", "2F", "2G", "2H", "3A", "3B", "3C", "3D", "3E", "3F", "3G", "3H", "4A", "4B", "4C", "4D", "4E", "4F", "4G", "4H"];

        const boards = ["C_1A", "C_1B", "C_1C", "C_1D", "C_1E", "C_1F", "C_1G", "C_1H", "C_2A", "C_2B", "C_2C", "C_2D", "C_2E", "C_2F", "C_2G", "C_2H", "C_3A", "C_3B", "C_3C", "C_3D", "C_3E", "C_3F", "C_3G", "C_3H", "C_4A", "C_4B", "C_4C", "C_4D", "C_4E", "C_4F", "C_4G", "C_4H"];

        axios
          .get(apiURL)
          .then(({ data }) => {
            this.board = data;
            this.totalSensorAll = data.map((totalSensor) => totalSensor.tags.totalSensor);

            for (let i = 0; i < bName.length; i++) {
              this[`boardName${bName[i]}`] = data.map((boardName) => boardName.fields[boards[i]].boardName);
              this[`phaseLabel${bName[i]}`] = data.map((phaseLabel) => phaseLabel.fields[boards[i]].ryb.label);
              this[`location${bName[i]}`] = data.map((location) => location.fields[boards[i]].location.location);
              this[`value${bName[i]}`] = data.map((value) => value.fields[boards[i]].value);
              this[`loadType${bName[i]}`] = data.map((loadType) => loadType.fields[boards[i]].loadType);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      },
      loadsBoardName: async function() {
        let apiURL = process.env.VUE_APP_API + "/api/board";
        axios
          .get(apiURL)
          .then((res) => {
            this.boardName = res.data;
            this.boardItem = this.boardName[0].boardName1;
            this.loadsBoard();
            this.loadsTotal();
            this.loading = true;
          })
          .catch((error) => {
            console.log(error);
          });
      },
      updateData(values) {
        this.values1 = values[0];
        this.values2 = values[1];
        this.$store.commit("setDateTime1", this.values1);
        this.$store.commit("setDateTime2", this.values2);
        this.loadsBoard();
        this.loadsTotal();
        this.loading = true;
      },

      updateBoard() {
        this.loadsBoard();
        this.loadsTotal();
        this.loading = true;
      },
    },
    beforeDestroy() {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", this.onResize, { passive: true });
      }
    },
  };
</script>

<style scoped>
  table,
  th,
  td {
    border: 2px groove;
  }
  th {
    background-color: rgb(35, 35, 35);
  }
  td {
    cursor: pointer;
  }
  .pick {
    position: sticky;
    top: 52px;
    z-index: 100;
  }
</style>
